<template>
  <div id="document-table">
    <b-table
      class="add-document-table"
      :items="orders"
      :fields="fields"
      striped
      bordered
    >
      <template slot="HEAD_select">
        <b-form-checkbox
          id="select-all-checkbox"
          v-model="allSelected"
          name="select-all-checkbox"
          :aria-describedby="orders"
          :aria-controls="orders"
          :indeterminate="indeterminate"
          :disabled="!isHospitalSelected || orders.length === 0"
          @change="toggleAll"
        />
      </template>
      <template slot="select" slot-scope="data">
        <b-form-checkbox
          v-model="checkedItems"
          :name="`select-all-checkbox-${data.item.id}`"
          :value="data.item"
          :disabled="!isHospitalSelected"
        />
      </template>
      <template slot="hospital" slot-scope="data">
        <a
          @click="
            setCustomerData(data.item.hospital_id).then(goHistoryCustomerAdding)
          "
        >
          <u>{{ data.item.hospital_name }}</u>
        </a>
      </template>
      <template slot="ln" slot-scope="data">
        <a
          @click="
            goResultDetail(
              data.item.id,
              data.item.animal_id,
              data.item.hospital_id,
              true
            )
          "
        >
          <u>{{ data.item.ln }}</u>
        </a>
      </template>
      <template slot="dn" slot-scope="data">
        {{ data.item.test_amount }}
      </template>
      <template slot="amount" slot-scope="data">
        {{ data.item.amount }}
      </template>
      <template slot="date" slot-scope="data">
        {{ data.item.order_date }}
      </template>
      <template slot="status" slot-scope="data">
        {{ data.item.latest_approve.user.name }}
      </template>
      <template slot="delete" slot-scope="data">
        <b-button class="del-order-btn" @click="deleteOrder(data.item.id)">
          ลบ
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddDocumentTable",
  props: {
    isHospitalSelected: {
      type: Boolean,
    },
    orderSelectItems: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters({
      orders: "Account/getFilterOrders",
    }),
  },
  mounted() {
    this.setOrders();
  },
  data() {
    return {
      fields: {
        select: {
          label: "",
        },
        hospital: {
          label: "รายชื่อลูกค้า",
        },
        ln: {
          label: "LN",
        },
        dn: {
          label: "จำนวนตรวจ",
        },
        amount: {
          label: "ราคารวม",
        },
        date: {
          label: "วันที่สั่งตรวจ",
        },
        status: {
          label: "อนุมัติ",
        },
        delete: {
          label: "",
        },
      },
      allSelected: false,
      indeterminate: false,
      checkedItems: [],
    };
  },
  methods: {
    ...mapActions({
      setOrders: "Account/setApproveOrder",
      filterOrders: "Account/filterData",
      setResult: "Result/setResult",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      setReadOnly: "Order/setReadOnly",
      setAdding: "History/setAdding",
    }),
    toggleAll(checked) {
      this.checkedItems = checked ? this.orders.slice() : [];
    },
    async goResultDetail(idOut, idAnimal, idHospital, readOnly) {
      await this.setResult(idOut);
      await this.setAnimalData(idAnimal);
      await this.setCustomerData(idHospital);
      this.setReadOnly(readOnly);
      this.$router.push({
        name: "result-detail",
        params: { read: readOnly },
      });
    },
    goHistoryCustomerAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      this.$router.push({ name: "history-customer-adding" });
    },
    deleteOrder(id) {
      // console.log(id);
    },
  },
  watch: {
    checkedItems(newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.orders.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
      this.$emit("update:orderSelectItems", newVal);
    },
  },
};
</script>

<style scoped>
a {
  color: black;
  cursor: pointer;
}
.add-document-table {
  margin-bottom: 0;
}
.del-order-btn {
  background-color: #e20000;
  border: none;
}
</style>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #fb822b;
  background-color: #fb822b;
}
.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::before {
  border-color: #fb822b;
  background-color: #fb822b;
}
</style>
